<template>
  <div class="table">
    <vxe-grid ref='xGrid' v-bind="gridOptions" :height="getHeight()" :row-style="{ height: '36px' }">
      <template #toolbar_buttons>
        <div style="display: flex;width: 100%;">
          <div>
            <el-button class="btn btn1" icon="el-icon-circle-plus-outline" @click="searchAddRel = true"
              :disabled="addPriv()">{{
                $t('message.button.add') }}
            </el-button>
            <el-button class="btn btn2" icon="el-icon-delete" @click="removeCheckbox" :disabled="removePriv()">{{
              $t('message.button.delete') }}
            </el-button>
            <!-- issure 771 添加交付件批量下载功能 -->
            <el-button class="btn btn3" icon="el-icon-paperclip" @click="downloadAttachment"
              :disabled="downloadPriv()">{{
                $t("message.button.downloadAttachment") }}</el-button>
          </div>
          <div style="margin-left: auto;margin-right: 10px;">
            <div class="edit-table" style="float: right;overflow: hidden;height: 33px;">
              <el-button class="btn btn7" icon="el-icon-document-checked" @click="getUpdateEvent" :disabled="statusPriv"
                v-if="!editShow">{{
                  $t('message.button.save') }}
              </el-button>
              <el-button class="btn btn8" icon="el-icon-circle-close" @click="closeSave" :disabled="statusPriv"
                v-if="!editShow">{{
                  $t('message.button.cancel') }}
              </el-button>
            </div>
          </div>

        </div>
      </template>
    </vxe-grid>


    <el-dialog v-if='searchAddRel' :title="$t('message.title.add')" :visible.sync="searchAddRel"
      :before-close="handleClose">
      <RelSearchAdd @listDbClick="addList" :baseId='baseId'></RelSearchAdd>
    </el-dialog>

  </div>
</template>

<script>
//;
import RelSearchAdd from '@/components/relSearchAdd.vue'; //引进菜单模板
// import  RelSearchAddNext from '@/components/relSearchAdd.vue';
import axios from "axios";
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      redLine: true,
      tabTitle: '',
      num: 0,
      chooseRel: false,
      baseId: 301,

      searchAddRel: false, //添加窗口开关
      oldTableValue: {},
      version: "",

      gridOptions: {
        keepSource: true,
        resizable: true,
        border: true,
        stripe: true,
        highlightHoverRow: true,
        highlightCurrentRow: true,
        showHeaderOverflow: true,
        showOverflow: true,
        autoResize: true,
        rowId: 'id',
        height: "560",
        size: "small",
        columns: [],
        data: [],

        toolbarConfig: {
          export: true,
          // print: true,
          zoom: true,
          custom: true,
          slots: {
            buttons: "toolbar_buttons",
          },
        },
        exportConfig: {
          remote: true,
          exportMethod: this.exportMethod,
          types: ['xlsx'],
          modes: ['current', 'selected', 'all']
        },

        editConfig: {
          trigger: 'dblclick',
          mode: 'cell',
          showIcon: false,
          activeMethod: this.activeRowMethod,
          showStatus: true,
        },
        sortConfig: {
          trigger: 'cell'
        },
      },
      editShow: false,
      leftShow: true,
      showBtn: false,
      isRootProject: false,

      cols: [], //表头
      rols_text: [], //表体显示内容
      tableShow: false, //显示table

      checkRow: {},

    }
  },
  mounted() {
    this.isRootProject = this.rootId == this.$store.state.objectId.id;
    console.log(this.isRootProject);
  },
  components: {
    RelSearchAdd,
  },

  methods: {

    addPriv() {
      const { add } = this.getPagePrivs();
      return !add || this.statusPriv;
    },
    removePriv() {
      const { remove } = this.getPagePrivs();
      return !remove || this.statusPriv;
    },
    downloadPriv() {
      const { download } = this.getPagePrivs();
      return !download || this.statusPriv;
    },

    getPagePrivs() {

      let [add, remove, download] = [true, true, true]
      if (this.$store.state.isSuperAdmin) {
        return { add, remove, download }
      }
      console.log(this.privsList);

      [add, remove, download] = [3, 4, 21].map(i => !!this.privsList.includes(i))
      return { add, remove, download }
    },

    getHeight() {
      const height = document.documentElement.clientHeight;
      // console.log(height);
      return height - 360
    },
    downloadAttachment() {
      let downloadRow = this.$refs.xGrid.getCheckboxRecords();
      var download_table = [];
      if (downloadRow.length == 0) {
        return false
      }

      for (let i = 0; i < downloadRow.length; i++) {
        download_table.push(downloadRow[i].rowId);
      };
      //console.log(del_table);
      var objId = {
        ... this.$store.state.objectId,
        subClassId: this.$store.state.objectId.subClassId
      };

      var relationshipMapVo = {
        delIds: download_table,
        objectId: objId
      };

      axios.post('swift-file/files/getFileDownloadUrlByIdList', relationshipMapVo).then(res => {
        if (res.data.code == 200) {

          let files = res.data.object;
          for (let i = 0; i < files.length; i++) {

            const iframe = document.createElement("iframe");
            iframe.style.display = "none"; // 防止影响页面
            iframe.style.height = 0; // 防止影响页面
            iframe.src = files[i].path;
            document.body.appendChild(iframe); // 这一行必须，iframe挂在到dom树上才会发请求
            // 5分钟之后删除
            setTimeout(() => {
              iframe.remove();
            }, 3 * 60 * 1000);
          }

        }
      })
        .catch(function (error) {
          console.log(error);
        });

    },
    showDetailEvent(row) {
      console.log(row);
      const name = row[0];
      const { objectId } = row;
      const obj = { ...objectId, name };
      this.getLink(obj)
    },

    removeCheckbox() { //删除
      let removeRow = this.$refs.xGrid.getCheckboxRecords();
      var del_table = [];
      if (removeRow.length == 0) {
        return false
      } else {
        for (let i = 0; i < removeRow.length; i++) {
          del_table.push(removeRow[i].rowId);
        };
        //console.log(del_table);
        var objId = {
          ... this.$store.state.objectId,
          subClassId: this.$store.state.objectId.subClassId
        };

        var relationshipMapVo = {
          delIds: del_table,
          objectId: objId
        };
        //console.log(delRelData);
        axios.post('/pmdm/relationship/deleteRelationShip', relationshipMapVo).then(res => {
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: 'success'
            });
            //console.log(res);
            this.getRelInfo();
            // this.gridOption2.data = [];
          }
        })
          .catch(function (error) {
            console.log(error);
          });
      }

    },
    addList(row) { //添加
      console.log(row);

      this.searchAddRel = false;
      let relationshipMapVo = {};
      let arr = row.map(i => {
        return {
          ctrObjid: this.$store.state.objectId.id,
          ctrObjtype: this.$store.state.objectId.classId,
          effObjid: i.itemId,
          effObjtype: i.itemClass,
          name: i[0],
        }
      }
      )
      relationshipMapVo.relationshipVoList = arr
      axios.post('/pmdm/relationship/saveRelationship', relationshipMapVo)
        .then(res => {
          console.log(res);
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: 'success'
            });
          };
          this.getRelInfo();
          this.$emit("routeClick");
        })
        .catch();
    },

    handleClose(done) {
      this.$confirm(this.$t('message.confirm.close'))
        .then(_ => {
          done();
        })
        .catch(_ => { });
    },

    closeSave() {
      this.$refs.xGrid.revertData(); //清除所有保存，删除，添加记录
    },
    getUpdateEvent(e) {

      let xGrid_ = this.$refs.xGrid;
      let columns = this.gridOptions.columns;
      let updateRecords = xGrid_.getUpdateRecords(); //获取修改的行
      let cols_length = this.cols;
      // console.log(cols_length);
      var updateRel = [];
      if (updateRecords.length !== 0) {//判断行内那些值有改动
        for (let i = 0; i < updateRecords.length; i++) {
          var num = xGrid_.getRowIndex(updateRecords[i]);
          // var cols_length = this.cols;
          for (let j = 0; j < cols_length.length; j++) {
            var updateNewData = xGrid_.isUpdateByRow(updateRecords[i], "" + j);
            // console.log(cols_length);
            if (updateNewData) {
              for (let k = 0; k < columns.length; k++) {
                var obj = {};
                if (cols_length[j] == columns[k].attid) {
                  var quantity = cols_length[j];
                  obj.id = updateRecords[i].rowId;
                  // console.log(columns[k]);
                  if (columns[k].editRender.props) {//处理多选和单选
                    if (columns[k].editRender.props.multiple) {
                      obj[quantity] = updateRecords[i][j].join(";")
                    } else if (columns[k].editRender.props.type == "datetime") {
                      // obj[quantity] = updateRecords[i][j].format("yyyy-MM-ddThh:mm:ss");
                      obj[quantity] = this.format(updateRecords[i][j], "yyyy-MM-ddThh:mm:ss");
                      // console.log(obj[quantity]);
                    } else {
                      if (updateRecords[i][j] == null) {
                        obj[quantity] = "";
                      } else {
                        obj[quantity] = updateRecords[i][j];
                      }
                    }
                  } else {
                    if (updateRecords[i][j] == null) {
                      obj[quantity] = "";
                    } else {
                      obj[quantity] = updateRecords[i][j];
                    }
                  };
                  updateRel.push(obj);
                }
              }
            }
          }
        };
        // console.log(updateRel);
        //var change_info = this.$store.state.change_info;
        var updateRelData = {//post更改的值
          tableId: 200,

          updateShip: this.ArrayFilter(updateRel)
        };
        // console.log(updateRelData);
        axios.post('/pmdm/items/updateTable', updateRelData)
          .then(res => {
            //console.log(res);
            if (res.data.code == 200) {
              this.$message({
                message: res.data.message,
                type: 'success'
              });
              if (e == 1) {
                this.getRelInfo();
              } else {
                this.checkRel(this.checkRow);
              }
              //xGrid_.revertData();
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      };

    },
    ArrayFilter(l) {
      let arr = l
      let list = arr.reduce((pre, cur) => {
        let target = pre.find(ee => ee.id == cur.id)
        if (target) {
          Object.assign(target, cur)
        } else {
          pre.push(cur)
        }
        return pre
      }, [])
      return list
    },
    activeRowMethod({ row }) {

      const { specialState = 0 } = this.projectStatus.specialProjectVo;
      console.log(this.projectStatus, this.projectEcrInfo);

      if (specialState !== 0) {
        return false
      }


      // if (row.disable) {
      //   return false
      // };
      //return true
      return !row.disable
    },
    editDisabledEvent({ row, column }) {
      this.$message.error(this.$t('message.error.noEdit'),)
    },
    editClick: function () {
      this.editShow = false;
    },

    getRelInfo() {

      var obj_get = {
        ... this.$store.state.objectId,
        tableId: 200
      };
      var loadTableUrl = `/ppm/project/loadTable${this.params(obj_get)}`;

      axios.get(loadTableUrl).then(res => {
        this.gridOptions.columns = this.getNewTableTitleData(res.data);
        this.cols = res.data.object.table.columnInfo.ids;

        this.rols_text = this.getNewTableContentData(res.data);
        const tableContent = this.getNewTableContentData(res.data);
        if (this.rols_text.length == 0) {
          this.chooseRel = false;
          this.gridOptions.height = 420;
        };
        this.$refs.xGrid.loadData(this.rols_text);
        this.tableShow = true;
        this.oldTableValue = tableContent;
        this.version = res.data.object.table.version;

        let rows = res.data.object.table.rows

        if (this.isRootProject) {
          axios.get('/ppm/project/getProjectBrowserInfo?rootId=' + this.rootId).then((res) => {

            let arr = this.getAllRow(this.transData([res.data.object.Info]));
            console.log(arr);
            let obj = {
              field: "projectInfo",
              minWidth: 200,
              title: "所属任务",
              fixed: null
            }
            this.gridOptions.columns.push(obj);
            this.rols_text.map((i, e) => {
              let seq = arr.find(j => j.id == rows[e].projectId).seq;
              i.projectInfo = seq + " " + rows[e].projectName + ' (' + rows[e].projectNumber + ')';
            })
          })
        }

      })
      this.$emit('refreshTab');
    },
    transData(e) {
      let getListName = (arr, l, pLevel) => {
        let newArr = [];
        let level = l || 1;
        let parentLevel = pLevel || 0;
        let m = 1;

        arr.map(i => {
          let n = {
            label: i.name,
            id: i.classId ? i.id : i.shipObjId,
            classId: i.classId || i.clsId,
            subclassId: i.subclassId || i.subClsId,
            children: i.childProject,
            seq: ''
          };
          if (n.classId == 30101 || n.classId == 30102) {
            n.seq = level == 1 ? '' : !parentLevel ? m : parentLevel + '.' + m,
              m++
          }
          n.children = i.childProject
          newArr.push(n);
          if (n.children?.length) {
            n.children = getListName(n.children, level + 1, n.seq);
          }
        });
        return newArr;
      };
      return getListName(e);
    },

    checkRel(row) {
      //console.log(row);
      this.chooseRel = true;
      this.gridOptions.height = 220;
      this.checkRow = row;
      this.nextCtrObjId = row.row.itemId;
      this.nextCtrObjClassId = row.row.itemClassId;
      this.tabTitle = row.row[0]
    },


  },
  computed: {

    ...mapGetters({
      projectStatus: "projectWorkflow/getProjectInfo",
      getPriv: "projectWorkflow/getPriv",
      projectEcrInfo: 'projectWorkflow/getCreateEcrInfo',
      privsList: 'btnPrivs/getPrivsList'
    }),
    statusPriv() {
      const {
        editProject,
        isExecuter,
        isAdministrator,
        editByStatusType,
        hasProjectPause,
      } = this.getPriv;
      return (!(isAdministrator || isExecuter) || !editByStatusType || hasProjectPause);
    },
  },

  created() {
    this.getRelInfo();
  },
  props: ['rootId'],

};
</script>

<style>
.RelSearchAddBomList .el-dialog__body {
  padding: 0 20px 20px 20px !important;
}

.el-table th.gutter {
  display: table-cell !important;
}

.link_ {
  color: #4b92ff;
  cursor: pointer;
}

.link_:hover {
  color: #4b92ff;
  cursor: pointer;
  border-bottom: 1px solid #4b92ff;
}

.mytable-style .vxe-body--column.col-red {
  text-decoration: line-through;
  color: red;
}

.mytable-style .vxe-body--column.col-red span {
  color: #000;
}

.mytable-style .vxe-body--column.col-red-text {
  color: red;
}

.mytable-style .vxe-body--column.col-red-text span {
  color: red;
}
</style>

<style scoped>
.table {
  background: #fff;
}

.content-title {
  padding: 0;
  margin: 0;
  overflow: hidden;
  background-size: 100% 100%;
  height: 40px;
  margin-left: 20px;
}

.content-title li {
  float: left;
  padding: 8px 8px 8px 8px;
  font-size: 14px;
  cursor: pointer;
  margin-right: 18px;
}

.content-title li:hover {
  border-bottom: 3px solid #4b92ff;
  color: #4b92ff;
}

.content-title .active {
  border-bottom: 3px solid #4b92ff;
  color: #4b92ff;
}
</style>